import moment from "moment";
import { parseApiDateTimeMoment } from "./apiDateTime";

const LEGACY_LOGIN_ACTIVITY_WITH_TIME = /^\d{1,2}\/\d{1,2}\/\d{4}\s+\d{1,2}:\d{2}/;

export function parseLoginActivityMoment(
  date: string | number | null | undefined
): moment.Moment | null {
  if (date === null || date === undefined) return null;
  if (typeof date === "string") {
    const trimmed = date.trim();
    if (!trimmed) return null;
    // Legacy login-activity values include an explicit time (e.g. 29/06/2026 19:32).
    // Date-only DD/MM/YYYY strings must not be treated as UTC midnight.
    if (LEGACY_LOGIN_ACTIVITY_WITH_TIME.test(trimmed)) {
      const parsed = moment(trimmed, "DD/MM/YYYY hh:mm A");
      if (parsed.isValid()) {
        return moment.utc(parsed.format("MM/DD/YYYY hh:mm A")).local();
      }
    }
  }
  return parseApiDateTimeMoment(date);
}
